import Vue from 'vue';
import { install as VueMonacoEditorPlugin } from '@guolao/vue-monaco-editor';
import CKEditor from 'ckeditor4-vue';
import Moment from 'vue-moment';
import VuePikaday from '@netcz/vue-pikaday';
import Vuetify from 'vuetify';
import pt from 'vuetify/es5/locale/pt';
import * as VeeValidate from 'vee-validate';
import VueMask from 'v-mask';
import VueAlertify from 'vue-alertify';
import SuiVue from 'semantic-ui-vue';
import VueCurrencyInput from 'vue-currency-input';
import VueScrollTo from 'vue-scrollto';
import * as VueGoogleMaps from 'vue2-google-maps';
import { Plugin } from 'vue-fragment';
import lodash from 'lodash';
import money from 'v-money';
import store from './store';

import App from './App.vue';
import router from './router';

import 'normalize.css';
import './global.css';
import '@netcz/vue-pikaday/dist/vue-pikaday.min.css';
import 'vuetify/dist/vuetify.min.css';
import 'alertifyjs/build/css/themes/semantic.min.css';

Vue.directive('uppercase', {
  update(el) {
    const sourceValue = el.value;
    if (typeof sourceValue === 'string') {
      const newValue = sourceValue.toUpperCase();
      if (sourceValue !== newValue) {
        const el2 = el;
        el.value = newValue;
        el2.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
  },
});

Vue.prototype.$focusNext = (e) => {
  const inputs = Array.from(e.target.form.querySelectorAll('input'));
  const index = inputs.indexOf(e.target);

  if (index < inputs.length) {
    let proximo = 1;
    let item = inputs[index + proximo];
    if (item.type && item.type == 'hidden') {
      proximo += 1;
      item = inputs[index + proximo];
    }
    if (item) {
      inputs[index + proximo].focus();
    }
  }
};

const vuetifyOptions = {
  icons: {
    iconfont: 'mdiSvg',
  },
  lang: {
    locales: { pt },
    current: 'pt',
  },
};

const veeConfig = {
  inject: true,
  events: '',
};

Vue.config.productionTip = false;
Vue.use(Plugin);
Vue.use(VeeValidate, veeConfig);
Vue.use(Moment);
Vue.use(VuePikaday);
Vue.use(Vuetify, vuetifyOptions);
Vue.use(VueMask);
Vue.use(VueCurrencyInput);
Vue.use(money, { precision: 4 });
Vue.use(VueAlertify, {
  transition: 'zoom',
  glossary: {
    title: 'Atenção',
    ok: 'OK',
    cancel: 'Cancelar',
  },
  theme: {
    input: 'ajs-input',
    ok: 'ui positive button',
    cancel: 'ui black button',
  },
});
Vue.use(VueCurrencyInput);
Vue.use(VueAlertify);
Vue.use(VueScrollTo);

Vue.use(SuiVue);
Vue.use(lodash);

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAxrRJdnisZUhtxkrY7pKUijrFOp0QI-N4',
    libraries: 'places',
    region: 'BR',
    language: 'pt-BR',
  },
});

Vue.use(VueMonacoEditorPlugin, {
  paths: {
    vs: 'https://cdn.jsdelivr.net/npm/monaco-editor@0.43.0/min/vs',
  },
});

Vue.use(CKEditor);

new Vue({
  router,
  store,
  render: (h) => h(App),
  vuetify: new Vuetify(vuetifyOptions),
}).$mount('#app');
